module.exports = __webpack_public_path__ + "static/media/level5-off.4020ae02.svg";